import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3b5aa24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uk-grid" }
const _hoisted_2 = {
  id: "qr-code-image",
  class: "uk-width-1-2"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "uk-width-1-2 uk-margin-top" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Please scan the QR code with your authenticator app. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" To verify your setup, please enter the current 6-digit authenticator code. ")
], -1))
const _hoisted_6 = { class: "uk-width-1-1 uk-margin-top uk-text-small" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "mfa-secret-key" }
const _hoisted_9 = {
  id: "button-container",
  class: "uk-text-right"
}

import { ref } from 'vue'
import Input from '@/components/Input.vue'

declare const UIkit

interface Props {
    qrUrl: string
    mfaSecret: string
    cancelText?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MFASetup',
  props: {
    qrUrl: { default: '' },
    mfaSecret: { default: '' },
    cancelText: { default: 'Cancel' }
  },
  emits: ['mfaUpdate', 'mfaCancel'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const mfaCode = ref('')

const emit = __emit

async function verifyMfaCode() {
    emit('mfaUpdate', mfaCode.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.qrUrl && _ctx.qrUrl.length)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              id: "mfa-code",
              src: _ctx.qrUrl,
              width: "200",
              height: "200",
              alt: "mfa-code"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(Input, {
          ref: "mfaCodeInput",
          modelValue: mfaCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mfaCode).value = $event)),
          class: "code-input",
          type: "number",
          title: "Your 6 digit code",
          placeholder: "Your 6 digit code",
          maxlength: "6",
          required: true,
          "err-msg": 'Please enter your 6 digit code',
          regex: /\d{6}/
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _createTextVNode(" No QR code scanner? "),
          _hoisted_7,
          _createTextVNode(" Please enter this secret key below into your preferred MFA app. "),
          _createElementVNode("code", _hoisted_8, _toDisplayString(_ctx.mfaSecret), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        class: "button uk-button back-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('mfaCancel')))
      }, _toDisplayString(_ctx.cancelText), 1),
      _createElementVNode("a", {
        class: "button primary verify-mfa-btn uk-button",
        onClick: verifyMfaCode
      }, "Verify MFA")
    ])
  ]))
}
}

})